"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchTerm = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _usePrevious = require("../../../../hooks/usePrevious/usePrevious");
var _react = require("react");
var useSearchTerm = function useSearchTerm(reopen, close, selectedOption, value, setSerchTermValue) {
  var _useState = (0, _react.useState)(function () {
      return selectedOption ? selectedOption.label.text : '';
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var previousValue = (0, _usePrevious.usePrevious)(value);
  var previousOption = (0, _usePrevious.usePrevious)(selectedOption);
  (0, _react.useEffect)(function () {
    if (value !== previousValue || (previousOption === null || previousOption === void 0 ? void 0 : previousOption.value) !== (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)) {
      // search opens a menu when the search term changes thats why close is called
      if (selectedOption && selectedOption.label.text !== searchTerm) {
        setSerchTermValue(selectedOption.label.text);
        close();
      } else if (selectedOption === undefined && searchTerm !== '') {
        setSerchTermValue('');
        close();
      }
    }
  }, [selectedOption, previousOption, close, searchTerm, value, previousValue, setSerchTermValue]);
  var handleChange = (0, _react.useCallback)(function (e) {
    var newSearch = e.currentTarget.value;
    if (newSearch === '') {
      reopen();
    }
    setSerchTermValue(newSearch);
  }, [reopen, setSerchTermValue]);
  return {
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm,
    handleChange: handleChange
  };
};
exports.useSearchTerm = useSearchTerm;